import { Component, ViewChild, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { ReleaseMgmtService } from '@app/shared/services/releaseMgmtService';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ICellRendererParams } from 'ag-grid-community';
import moment from 'moment';
import { DeploymentStatusDto } from '@app/apiModules/DeploymentStatusDto';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { PageHeaderComponent } from '@app/shared/page-header/page-header.component';
import { CommonModule } from '@angular/common';
import { DeploymentCommentComponent } from '../deployment-comment/deployment-comment.component';
import { StatusLogComponent } from '../status-log/status-log.component';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { LoaderService } from '@app/shared/services/loader.service';

@Component({
    standalone: true,
    selector: 'app-release-deployment-status-dtls',
    templateUrl: './release-deployment-status-dtls.component.html',
    styleUrls: ['./release-deployment-status-dtls.component.scss'],
    imports: [AgGridModule, MatIconModule, PageHeaderComponent, CommonModule, RouterModule]
})
export class ReleaseDeploymentStatusDetailsComponent implements OnChanges, OnInit {
    @ViewChild('agGrid') agGrid: AgGridAngular;
      styleChipDiv = "width:100%; height: calc(100vh - 230px); flex: 1 1 auto; border: 1px solid #DFDFDF;";

    releaseId: number = 0;
    paginationPageSize = 30;
    infiniteInitialRowCount =30;
    overlayNoRowsTemplate = `<span style="font-weight: 400; color: #757575;  ">No records found</span>`;
    rowData: DeploymentStatusDto[] = [];
    filteredRowData: DeploymentStatusDto[] = [];
    pageTitle: string = 'Release Deployment Status';
    pageSubTitle: string = 'View the deployment status details for the selected release';
    columnDefs = [
        { 
            headerName: 'Deployment ID', 
            field: 'deploymentId', 
            filter: true,
            minWidth: 150,width:150,
            cellStyle: { textAlign: 'left' },
            tooltipField: 'deploymentId'
        },
        { 
            headerName: 'Environment', 
            field: 'environmentName', 
            filter: true,
            minWidth: 180,width:180,
            cellStyle: { textAlign: 'left' },
            tooltipField: 'environmentName'
        },
        {
            headerName: 'Staging DB Sync Status',
            field: 'dbSyncStatus',
            filter: true,
            cellStyle: { padding: '0 8px' },
            tooltipField: 'dbSyncStatus',
            cellRenderer: params => {
                const btnStyle = `
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 105px;
                    height: 25px;
                    min-width: 100px;
                    padding: 0 12px;
                    border-radius: 16px;
                    font-weight: 500;
                    cursor: default;
                    white-space: nowrap;
                    border: none;
                    box-shadow: 0 1px 2px rgba(60,60,60,0.07);
                `;
                if (params.value === null || params.value === undefined || params.value === '') {
                    params.value = 'NA';
                }
                const status = params.value ? params.value.toLowerCase() : '';
                if (status === 'success') {
                    return `<span style="${btnStyle} background: #168736; color: #fff; border: none;">${params.value}</span>`;
                }
                if (status === 'partial success') {
                    return `<span style="${btnStyle} background: #fff; color: #168736; border: 3px solid #168736;">${params.value}</span>`;
                }
                if (status === 'in progress') {
                    return `<span style="${btnStyle} background: #ED6500; color: #fff; border: none;">${params.value}</span>`;
                }
                if (status === 'failed') {
                    return `<span style="${btnStyle} background: #ed0000; color: #fff; border: none;">${params.value}</span>`;
                }
                 return `<span style="${btnStyle} background: #BDBDBD; color: #212121; border: none;">${params.value}</span>`;
            }
        },
        {
            headerName: 'Deployment Stage',
            field: 'deploymentStage',
            filter: true,
            minWidth: 200,width:200,
            cellStyle: { textAlign: 'left' },
            tooltipField: 'deploymentStage',
            cellRenderer: params => {
                const stages = (params.value || '').split(',');
                let displayText = stages.slice(0, 1).join(', ');
                if (stages.length > 1) {
                    displayText += ', ...';
                }
                return `<span style="cursor: pointer;">${displayText}</span>`;
            }
        },
        {
            headerName: 'Deployment Status',
            field: 'status',
            filter: true,
            minWidth: 200,width:200,
            cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
            tooltipField: 'status',
            cellRenderer: params => {
                const btnStyle = `
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 105px;
                    height: 25px;
                    min-width: 100px;
                    padding: 0 12px;
                    border-radius: 16px;
                    font-weight: 500;
                    cursor: default;
                    white-space: nowrap;
                    border: none;
                    box-shadow: 0 1px 2px rgba(60,60,60,0.07);
                `;
                const status = params.value ? params.value.toLowerCase() : '';
                if (status === 'success') {
                    return `<span style="${btnStyle} background: #168736; color: #fff; border: none;">${params.value}</span>`;
                }
                if (status === 'partial success') {
                    return `<span style="${btnStyle} background: #fff; color: #168736; border: 3px solid #168736;">${params.value}</span>`;
                }
                if (status === 'in progress') {
                    return `<span style="${btnStyle} background: #ED6500; color: #fff; border: none;">${params.value}</span>`;
                }
                if (status === 'failed') {
                    return `<span style="${btnStyle} background: #ed0000; color: #fff; border: none;">${params.value}</span>`;
                }
                 return `<span style="${btnStyle} background: #BDBDBD; color: #212121; border: none;">${params.value}</span>`;
            }
        },
        {
            headerName: 'Deployment Purpose',
            field: 'deploymentPurpose',
             minWidth: 200,width:200,
             filter: false, sortable: false, 
            cellRenderer: params => {
                return `<a class="ag-link" style="color: #1976d2; font-weight: 400; text-decoration: underline; cursor: pointer;">View Details</a>`;
            },
            onCellClicked: (params) => {
                this.openDeploymentDialog(params.data);
            }
        },
        { 
            headerName: 'Triggered By', 
            field: 'triggeredBy', 
             minWidth: 200,width:200,
            filter: true, 
            cellStyle: { textAlign: 'left' },
            tooltipField: 'triggeredBy'
        },
        {
            headerName: 'Triggered On',
            dataType: "date",
            field: 'triggeredOn',
            filter: 'agDateColumnFilter',
            minWidth: 200, width: 200,
            cellStyle: { textAlign: 'left' },
            tooltipValueGetter: (params: ICellRendererParams) => params.value ? moment(params.value).format('MMM DD, YYYY, HH:mm A') : '',
            cellRenderer: (params: ICellRendererParams) => {
                let formattedDate = params.value ? moment(params.value).format('MMM DD, YYYY, HH:mm A') : '';
                return formattedDate;
            },
            filterParams: {
                buttons: ['clear'],
                filterOptions: ['equals'],
                defaultOption: 'equals',
                suppressAndOrCondition: true,
                comparator: (filterLocalDateAtMidnight, cellValue) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue);
                    if (
                        cellDate.getFullYear() === filterLocalDateAtMidnight.getFullYear() &&
                        cellDate.getMonth() === filterLocalDateAtMidnight.getMonth() &&
                        cellDate.getDate() === filterLocalDateAtMidnight.getDate()
                    ) {
                        return 0;
                    }
                    return -1;
                }
            }
        },
        {
            headerName: 'Trigger completed',
            dataType: "date",
            filter: 'agDateColumnFilter',

            minWidth: 200, width: 200,
            field: 'lastUpdatedOn',
            cellStyle: { textAlign: 'left' },
            tooltipValueGetter: (params: ICellRendererParams) => params.value ? moment(params.value).format('MMM DD, YYYY, HH:mm A') : '',
            cellRenderer: (params: ICellRendererParams) => {
                let formattedDate = params.value ? moment(params.value).format('MMM DD, YYYY, HH:mm A') : '';
                return formattedDate;
            },
            filterParams: {
                buttons: ['clear'], 
                filterOptions: ['equals'],
                defaultOption: 'equals',
                suppressAndOrCondition: true,
                comparator: (filterLocalDateAtMidnight, cellValue) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue);
                    if (
                        cellDate.getFullYear() === filterLocalDateAtMidnight.getFullYear() &&
                        cellDate.getMonth() === filterLocalDateAtMidnight.getMonth() &&
                        cellDate.getDate() === filterLocalDateAtMidnight.getDate()
                    ) {
                        return 0;
                    }
                    return -1;
                }
            }
        },
        {
            headerName: 'Status Log',
            field: 'statusLog',
             filter: false, sortable: false, 
             minWidth: 150,width:150,
            cellRenderer: params => {
                const statusFailed = params.data?.status?.toLowerCase() === 'failed';
                const dbSyncFailed = params.data?.dbSyncStatus?.toLowerCase() === 'failed';
                if (statusFailed || dbSyncFailed) {
                    return `<a class="ag-link" style="color: #1976d2; font-weight: 400; text-decoration: underline; cursor: pointer;">View Details</a>`;
                }
                return '';
            },
            onCellClicked: (params) => {
                const statusFailed = params.data?.status?.toLowerCase() === 'failed';
                const dbSyncFailed = params.data?.dbSyncStatus?.toLowerCase() === 'failed';
                if (statusFailed || dbSyncFailed) {
                    this.openStatusDialog(params.data);
                }
            }
        }
    ];

    defaultColDef = {
        minWidth: 0,
        with: 0,
        resizable: true,
        sortable: true,
        filter: true,
    };
    releaseTitle: string = '';
    ShowHealthStatus: boolean = false;
    isRefreshing: boolean;

    constructor(private ReleaseMgmtService: ReleaseMgmtService, public route: ActivatedRoute, public dialog: MatDialog,
        public readonly userAuthService: UserAuthService,public readonly router: Router,
                public loader: LoaderService
        
    ) { }
    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params['releaseId']) {
                this.releaseId = params['releaseId'];
            }
        });
    }
    openDeploymentDialog(dta: DeploymentStatusDto) {
        const dialogConfig = new MatDialogConfig(); //NOSONAR - Deprecation has been applied during migration. To remove warning, control has to be upgraded as per current version of Angular Library.
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = '550px';
        dialogConfig.width = '800px';
        dialogConfig.data = {
            title: "Deployment Purpose",
            popupcontent: dta.deploymentPurpose
        };
        const dialogRef = this.dialog.open(DeploymentCommentComponent, dialogConfig);


    }
    openStatusDialog(dta: DeploymentStatusDto) {
        const dialogConfig = new MatDialogConfig(); //NOSONAR - Deprecation has been applied during migration. To remove warning, control has to be upgraded as per current version of Angular Library.
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = '550px';
        dialogConfig.width = '800px';
        dialogConfig.data = {
            title: "Status Log",
            popupcontent: JSON.stringify(dta.statusLog)
        };
        const dialogRef = this.dialog.open(StatusLogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(
            flag => {

            }
        );
    }

    /* istanbul ignore next */
    onGridReady(params: any) {
        if (!params) return;
        this.agGrid.api = params.api;
        this.agGrid.columnApi = params.columnApi;
        this.filterByServiceId();

        setTimeout(() => {
            const allColumnIds: string[] = [];
            params.columnApi.getAllColumns().forEach((column: any) => {
                allColumnIds.push(column.getColId());
            });
            params.columnApi.autoSizeColumns(allColumnIds, false); // false = size to fit header and cell content
        });
    }

    /* istanbul ignore next */
    refreshTable() {
        this.filterByServiceId();
    }


    ngOnChanges(changes: SimpleChanges) {
        if (changes['serviceId']) {
            this.filterByServiceId();
        }
    }

    filterByServiceId() {
        this.isRefreshing = true;
                this.loader.showSpinner.next(true);

        this.ReleaseMgmtService.apiGetReleaseStatusDetail(this.releaseId).subscribe({
            next: (response: DeploymentStatusDto[]) => {
                this.rowData = response || [];
                this.filteredRowData = response || [];
                if (this.agGrid?.api) {
                    this.releaseTitle = this.rowData.length > 0 ? this.rowData[0].releaseName : '';
                    this.agGrid.api.setRowData(this.filteredRowData);

                    // Auto-size columns after data is set
                    const allColumnIds: string[] = [];
                    this.agGrid.columnApi.getAllColumns().forEach((column: any) => {
                        allColumnIds.push(column.getColId());
                    });
                    this.agGrid.columnApi.autoSizeColumns(allColumnIds, false);
                    this.ShowHealthStatus = this.rowData.length > 0;
                }
                                this.loader.showSpinner.next(false);

            },
            error: (error) => {
                console.error('Error fetching branch creation status:', error);
                this.loader.showSpinner.next(false);

                this.rowData = [];
                this.filteredRowData = [];
                if (this.agGrid?.api) {
                    this.agGrid.api.setRowData([]);
                    this.agGrid.api.sizeColumnsToFit();
                }

            }
        });
        this.isRefreshing = false;

    }
    
    navigateToHealthStatus() {
  this.router.navigate(['/release/release-deployment-dtls/health-status', this.releaseId]);
}
}
